import React from 'react'
import GridLoader from 'react-spinners/GridLoader'


export class Loading extends React.Component {
  render() {
    const defaultConfig = { color: '#2D3748', type: 'Grid', height: 40, width: 40 }
    const config = { ...defaultConfig, ...this.props }

    return <GridLoader {...config} />
  }
}